<template>
    <module-section>
        <div class="row" v-for="(row, i) in data" :key="i">
            <div class="col" v-for="(col, j) in row" :key="j" @click="handleToArticle(col.menu2Id)">
                <img :src="col.img" :title="col.name" />
                <h3>{{ col.name }}</h3>
                <p>{{ col.intro }}</p>
            </div>
        </div>
        <div class="btn" v-if="data.length !== allData.length" @click="handlePage">More SIE News ></div>
    </module-section>
</template>

<script>
import ModuleSection from './ModuleSection.vue'

export default {
    components: {
        ModuleSection
    },
    props: {
        list: {
            type: Array,
            require: true
        }
    },
    data() {
        return {
            page: 1,
            size: 6,
            data: [],
            allData: []
        }
    },
    created() {
        const data = [];
        let row = [],
            index = 1;
        this.list.map(item => {
            if (index % 3 !== 0) {
                row.push(item);
            } else {
                row.push(item);
                data.push(row)
                row = [];
            }
            index++;
        })
        this.allData = Object.freeze(data)
        this.handlePage()
    },
    methods: {
        handlePage() {
            this.data.push(this.allData[this.page - 1]);
            this.data.push(this.allData[this.page]);
            this.page += 2;
        },
        handleToArticle(menu2Id) {
            const menu1Id = this.$route.query.menu_id;
            this.$router.push({
                path: `/article?menu_id=${menu1Id}&menu2Id=${menu2Id}`
            })
        }
    }
}
</script>

<style lang="scss" scoped>
$h3: 18px;
$primaryColor: #b1040e;
$gutterX: 60px;
$gutterY: 30px;

.row {
    display: flex;
    margin-bottom: $gutterY;

    &:last-child {
        margin-bottom: 0;
    }
}

.col {
    flex: 1;
    box-shadow: 6px 6px 6px #999;
    margin-right: $gutterX;
    cursor: pointer;

    &:last-child {
        margin-right: 0;
    }

    img {
        width: 100%;
    }

    h3 {
        padding: 20px 30px 5px;
        font-size: $h3;
        font-weight: 700;
        color: $primaryColor;
    }

    p {
        padding: 5px 30px 20px;
        font-size: 14px;
    }
}

.btn {
    margin: 0 auto;
    width: 300px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    color: #fff;
    background-color: $primaryColor;
    cursor: pointer;
}
</style>
